import { ErrorlessRepository as Repository } from '../../../repositories/Repository';
import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

export default {
  state: {
    locks: [],
  },
  actions,
  mutations,
  getters,
};

export const LockRepository = {
  fetch(key) {
    return Repository.get(`/locks/${key}`)
      .then((response) => {
        return response.data;
      });
  },
  lock(key) {
    return Repository.post('/locks', {key: key})
      .then((response) => {
        return response.data;
      });
  },
  refresh(key) {
    return Repository.put(`/locks/${key}`, {key: key})
      .then((response) => {
        return response.data;
      });
  },
  release(key) {
    return Repository.delete(`/locks/${key}`);
  },
};

/**
 * Validates and returns a key for use with the resource locks api.
 * 
 * @param {string|int|array} key
 * @returns {string}
 */
export const keyify = (key) => {
  if (Array.isArray(key)) {
    if (key.length <= 0) {
      return '';
    }

    key = key.join('-');
  }

  return String(key);
};

/**
 * Utility helper which returns whether a lock exists in the given lock array, and has no errors.
 * 
 * @param {array} locks 
 * @param {string|int|array} key 
 * @returns {boolean}
 */
export const hasLock = (locks, key) => {
  key = keyify(key);
  const item = locks.find(l => l.key === key);
  if (!item) {
    return false;
  }

  if (item.error) {
    return false;
  }

  return true;
};

/**
 * delay returns a promise after the executed number of milliseconds passes.
 * 
 * @param {Number} ms milliseconds to delay.
 * @returns {Promise}
 */
export const delay = async (ms) => {
  return await new Promise(resolve => setTimeout(resolve, ms));
};
